import PropTypes from 'prop-types';
import React from 'react';
import IconArrowRight from '$partials/icons/icon-arrow-right';
import NativeImage from '$partials/media/native-image.jsx';
import { formatUrlWithActiveFund } from '$utilities/format';
import Link from '$partials/global/link';
import { DetailDialogProvider } from '$pages/detail/detail-page-provider';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CompaniesListing = ({ sidebarTitle, items, ctaLink, ctaLabel }) => {

    return (
        <div className='layout-container-padding-right flex flex-wrap max-w-container pt-70 sm:pt-80 pb-70'>
            {/* Left Sidebar */}
            <div className='w-sidebar'>
                <div className='flex flex-col items-center'>
                    <h2 className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                        {sidebarTitle}
                    </h2>
                </div>
            </div>

            <div className='flex-1 layout-negative-margin'>
                <section className='layout-item-padding'>
                    {items?.length > 0 && (
                        <DetailDialogProvider isCompanyPage={true}>
                            <ul className='w-full flex flex-wrap gap-y-40 md:gap-y-60'>
                                {items.map((item, i) => {
                                    return (
                                        <li
                                            className='basis-6/12 sm:basis-3/12 flex items-center'
                                            key={`external-link-${i}-${item.id}`}>
                                            <Link
                                                aria-label={item.page?.title}
                                                href={item.page?.url}>
                                                {item?.page?.listingImage && (
                                                    <NativeImage
                                                        className='object-contain object-left-top sm:min-w-[80px] sm:max-w-[180px] md:max-w-[260px] sm:h-30 md:h-50 w-full'
                                                        {...item.page.listingImage} />
                                                )}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </DetailDialogProvider>
                    )}
                </section>

                <div className='mt-30 sm:mt-50 md:mt-60 layout-item-padding'>
                    {ctaLabel && ctaLink?.url && (
                        <a
                            className='bg-grey px-12 py-5 sm:py-8 rounded-3xl h-fit arrow-button'
                            href={formatUrlWithActiveFund(ctaLink.url)}>
                            <span className='inline-flex items-center gap-5'>
                                {ctaLabel}
                                <IconArrowRight />
                            </span>
                        </a>
                    )}
                </div>
            </div>

        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.array,
    ctaLink: PropTypes.object,
    ctaLabel: PropTypes.string,
    sidebarTitle: PropTypes.string,
};

CompaniesListing.propTypes = propTypes;

export default CompaniesListing;
